/**
 * Slick slider
 */

(function($) {

  $('.testimonial-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: false,
    slide: 'div',
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 480,
        // settings: {
        //   autoplay: false,
        // }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

})(jQuery);
